"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StackItem = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["children", "className"];

var StackItem = function StackItem(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])('stackItem', className)
  }, props), children);
};

exports.StackItem = StackItem;
StackItem.displayName = 'StackItem';
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTdGFja0l0ZW0iLCJjaGlsZHJlbiIsImNsYXNzTmFtZSIsInByb3BzIiwiY2xhc3NuYW1lcyIsImRpc3BsYXlOYW1lIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvU3RhY2svU3RhY2tJdGVtLnRzeCJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgY2xhc3NuYW1lcyBmcm9tICdjbGFzc25hbWVzJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmludGVyZmFjZSBQcm9wcyBleHRlbmRzIFJlYWN0LkhUTUxBdHRyaWJ1dGVzPEhUTUxEaXZFbGVtZW50PiB7fVxuXG5leHBvcnQgY29uc3QgU3RhY2tJdGVtOiBSZWFjdC5GQzxSZWFjdC5Qcm9wc1dpdGhDaGlsZHJlbjxQcm9wcz4+ID0gKHtcbiAgY2hpbGRyZW4sXG4gIGNsYXNzTmFtZSxcbiAgLi4ucHJvcHNcbn0pID0+IChcbiAgPGRpdiBjbGFzc05hbWU9e2NsYXNzbmFtZXMoJ3N0YWNrSXRlbScsIGNsYXNzTmFtZSl9IHsuLi5wcm9wc30+XG4gICAge2NoaWxkcmVufVxuICA8L2Rpdj5cbik7XG5cblN0YWNrSXRlbS5kaXNwbGF5TmFtZSA9ICdTdGFja0l0ZW0nO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUE7O0FBQ0E7Ozs7QUFJTyxJQUFNQSxTQUFtRCxHQUFHLFNBQXREQSxTQUFzRDtFQUFBLElBQ2pFQyxRQURpRSxRQUNqRUEsUUFEaUU7RUFBQSxJQUVqRUMsU0FGaUUsUUFFakVBLFNBRmlFO0VBQUEsSUFHOURDLEtBSDhEO0VBQUEsb0JBS2pFO0lBQUssU0FBUyxFQUFFLElBQUFDLHNCQUFBLEVBQVcsV0FBWCxFQUF3QkYsU0FBeEI7RUFBaEIsR0FBd0RDLEtBQXhELEdBQ0dGLFFBREgsQ0FMaUU7QUFBQSxDQUE1RDs7O0FBVVBELFNBQVMsQ0FBQ0ssV0FBVixHQUF3QixXQUF4QiJ9